import { useEffect, useState } from 'react';
import { InvoiceAIExtractionFieldMap } from '../../../../../../utils/globalEnums';

const parsePolygon = (polygon) =>
  polygon
    ?.split(';')
    .map((pair) => {
      const [x, y] = pair.split(',').map(Number);
      return Number.isFinite(x) && Number.isFinite(y) ? { x, y } : null;
    })
    .filter(Boolean) || [];

const toComparableFileName = (name) => String(name || '').trim().toLowerCase().replace(/\.[^/.]+$/, '');

export const useBobAIHighlightRegion = ({ selectedFileId, invoiceFiles, invoiceAnalyzeLogs }) => {
  const [hoveredBobAIMeta, setHoveredBobAIMeta] = useState(null);
  const [pdfHighlightRegion, setPdfHighlightRegion] = useState(null);

  const resolveRegionForMeta = (meta) => {
    const selectedFor = InvoiceAIExtractionFieldMap?.[meta?.fieldName];
    if (!selectedFor) return null;

    const activeFile =
      selectedFileId === 0
        ? invoiceFiles?.find((f) => f.invoiceAttachmentCategoryId === 1)
        : invoiceFiles?.find((f) => Number(f.id) === Number(selectedFileId));
    const activeFileComparable = toComparableFileName(activeFile?.fileName);
    if (!activeFileComparable) return null;

    const row = invoiceAnalyzeLogs?.find((row) => {
      const rowFile = toComparableFileName(row.fileName);
      return selectedFor.includes(row.selectedFor) && row.boundingPolygon && rowFile === activeFileComparable;
    });

    if (!row) return null;

    const polygonPoints = parsePolygon(row.boundingPolygon);

    return polygonPoints.length ? { pageNumber: row.boundingPageNumber, polygonPoints } : null;
  };

  const handleBobAIHoverStart = (meta) => {
    setHoveredBobAIMeta(meta);
    setPdfHighlightRegion(resolveRegionForMeta(meta));
  };

  const handleBobAIHoverEnd = () => {
    setHoveredBobAIMeta(null);
    setPdfHighlightRegion(null);
  };

  useEffect(() => {
    if (!hoveredBobAIMeta) return;
    setPdfHighlightRegion(resolveRegionForMeta(hoveredBobAIMeta));
  }, [hoveredBobAIMeta, selectedFileId, invoiceFiles, invoiceAnalyzeLogs]);

  return { pdfHighlightRegion, handleBobAIHoverStart, handleBobAIHoverEnd };
};
